(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const syncFooterDetails = () => {
      document.querySelectorAll('.syntax-footer__item').forEach((item) => {
        item.open = !mobileQuery.matches;
      });
    };

    syncFooterDetails();
    mobileQuery.addEventListener('change', syncFooterDetails);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!window.syntaxPageLoaderInitialized) {
    window.syntaxPageLoaderInitialized = true;

    let loaderTimer;
    let activeSlowRequests = 0;
    let lastClickInteraction = 0;
    let navigationPending = false;

    const showPageLoader = () => {
      window.clearTimeout(loaderTimer);
      document.documentElement.classList.add('checkout-transition-active');
      document.body?.setAttribute('aria-busy', 'true');
    };

    const schedulePageLoader = (delay = 350) => {
      window.clearTimeout(loaderTimer);
      loaderTimer = window.setTimeout(showPageLoader, delay);
    };

    const hidePageLoader = () => {
      if (navigationPending || activeSlowRequests > 0) return;
      window.clearTimeout(loaderTimer);
      document.documentElement.classList.remove('checkout-transition-active');
      document.body?.removeAttribute('aria-busy');
    };

    const isRealNavigation = (link) => {
      if (!link || link.hasAttribute('download') || link.hasAttribute('data-no-page-loader')) return false;
      if (link.target && link.target !== '_self') return false;

      const rawHref = link.getAttribute('href');
      if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) return false;
      if (rawHref.startsWith('javascript:')) return false;

      const nextUrl = new URL(link.href, window.location.href);
      const samePage =
        nextUrl.origin === window.location.origin &&
        nextUrl.pathname === window.location.pathname &&
        nextUrl.search === window.location.search;

      return !(samePage && nextUrl.hash);
    };

    document.addEventListener('click', (event) => {
      if (event.isTrusted && event.button === 0) lastClickInteraction = Date.now();
    }, true);

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const checkoutButton = event.target.closest('#CartDrawer-Checkout');
      if (checkoutButton && !checkoutButton.disabled && checkoutButton.dataset.transitionStarted !== 'true') {
        const checkoutForm = checkoutButton.form || checkoutButton.closest('form');
        if (!checkoutForm) return;

        event.preventDefault();
        navigationPending = true;
        checkoutButton.dataset.transitionStarted = 'true';
        checkoutButton.setAttribute('aria-busy', 'true');
        showPageLoader();

        window.setTimeout(() => {
          if (typeof checkoutForm.requestSubmit === 'function') {
            checkoutForm.requestSubmit(checkoutButton);
            return;
          }

          const checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = 'Checkout';
          checkoutForm.appendChild(checkoutInput);
          checkoutForm.submit();
        }, 560);
        return;
      }

      const navigationLink = event.target.closest('a[href]');
      if (isRealNavigation(navigationLink)) {
        navigationPending = true;
        schedulePageLoader();
      }
    });

    document.addEventListener('submit', (event) => {
      if (event.defaultPrevented || event.target.hasAttribute('data-no-page-loader')) return;
      if (Date.now() - lastClickInteraction > 1000) return;
      navigationPending = true;
      schedulePageLoader();
    });

    const nativeFetch = window.fetch.bind(window);
    window.fetch = (...args) => {
      const watchRequest = Date.now() - lastClickInteraction < 1000;
      let requestBecameSlow = false;
      let requestTimer;

      if (watchRequest) {
        requestTimer = window.setTimeout(() => {
          requestBecameSlow = true;
          activeSlowRequests += 1;
          showPageLoader();
        }, 450);
      }

      return nativeFetch(...args).finally(() => {
        window.clearTimeout(requestTimer);
        if (requestBecameSlow) activeSlowRequests = Math.max(0, activeSlowRequests - 1);
        hidePageLoader();
      });
    };

    window.addEventListener('pageshow', () => {
      navigationPending = false;
      activeSlowRequests = 0;
      document.documentElement.classList.remove('checkout-transition-active');
      document.body?.removeAttribute('aria-busy');
      document.querySelectorAll('#CartDrawer-Checkout[data-transition-started="true"]').forEach((button) => {
        button.removeAttribute('aria-busy');
        delete button.dataset.transitionStarted;
      });
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.querySelectorAll('[data-inline-search]').forEach((search) => {
    const form = search.querySelector('[data-inline-search-form]');
    const textInput = search.querySelector('.header__inline-search-input');
    const fileInput = search.querySelector('[data-visual-search-input]');
    const status = search.querySelector('[data-visual-search-status]');
    const closeButton = search.querySelector('[data-inline-search-close]');
    const summary = search.querySelector('summary');
    const header = search.closest('.header');
    const logo = header.querySelector('.header__heading-link');
    const updateDesktopSearchWidth = () => {
      if (!window.matchMedia('(min-width: 990px)').matches || !logo) return;
      const logoRight = logo.getBoundingClientRect().right;
      const searchRight = summary.getBoundingClientRect().right;
      const availableWidth = Math.max(44, Math.floor(searchRight - logoRight - 12));
      search.style.setProperty('--desktop-search-width', `${availableWidth}px`);
    };
    updateDesktopSearchWidth();
    summary.addEventListener('click', updateDesktopSearchWidth);
    window.addEventListener('resize', updateDesktopSearchWidth, { passive: true });
    search.addEventListener('toggle', () => {
      if (search.open) window.requestAnimationFrame(() => textInput.focus());
    });
    closeButton.addEventListener('click', () => {
      search.removeAttribute('open');
      summary.focus();
    });
    fileInput.addEventListener('change', () => {
      const file = fileInput.files[0];
      status.hidden = !file;
      status.textContent = file ? file.name : '';
    });
    form.addEventListener('submit', (event) => {
      const file = fileInput.files[0];
      if (!file) return;
      event.preventDefault();
      const visualSearchEvent = new CustomEvent('visual-search:submit', {
        bubbles: true,
        cancelable: true,
        detail: { file, query: textInput.value }
      });
      const handled = !form.dispatchEvent(visualSearchEvent);
      if (!handled) {
        status.hidden = false;
        status.textContent = 'Connect your visual search app to the visual-search:submit event.';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!window.productOfferCopyReady) {
    window.productOfferCopyReady = true;

    const updateOfferArrows = (offers) => {
      const track = offers.querySelector('.product-offers__track');
      const previous = offers.querySelector('[data-offer-scroll="previous"]');
      const next = offers.querySelector('[data-offer-scroll="next"]');

      if (!track || !previous || !next) return;

      const hasOverflow = track.scrollWidth > track.clientWidth + 2;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };

    const initializeOfferArrows = (scope = document) => {
      scope.querySelectorAll('.product-offers').forEach((offers) => {
        const track = offers.querySelector('.product-offers__track');
        if (!track) return;

        updateOfferArrows(offers);

        if (track.dataset.offerArrowsReady !== 'true') {
          track.dataset.offerArrowsReady = 'true';
          track.addEventListener('scroll', () => updateOfferArrows(offers), { passive: true });
        }
      });
    };

    const copyOfferCode = async (value) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
    };

    document.addEventListener('click', async (event) => {
      const arrow = event.target.closest('[data-offer-scroll]');
      if (arrow) {
        const offers = arrow.closest('.product-offers');
        const track = offers ? offers.querySelector('.product-offers__track') : null;

        if (track) {
          const direction = arrow.dataset.offerScroll === 'previous' ? -1 : 1;
          const cards = Array.from(track.querySelectorAll('.product-offers__card'));
          if (cards.length === 0) return;
          const trackLeft = track.getBoundingClientRect().left;
          const positions = cards.map((card) => card.getBoundingClientRect().left - trackLeft + track.scrollLeft);
          let currentIndex = 0;

          positions.forEach((position, index) => {
            if (Math.abs(position - track.scrollLeft) < Math.abs(positions[currentIndex] - track.scrollLeft)) {
              currentIndex = index;
            }
          });

          const targetIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction));
          track.scrollTo({ left: positions[targetIndex], behavior: 'smooth' });
        }
        return;
      }

      const button = event.target.closest('[data-offer-copy]');
      if (!button) return;

      try {
        await copyOfferCode(button.dataset.offerCopy);
        button.classList.add('is-copied');
        window.setTimeout(() => button.classList.remove('is-copied'), 1600);
      } catch (error) {
        button.classList.remove('is-copied');
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeOfferArrows());
    } else {
      window.requestAnimationFrame(() => initializeOfferArrows());
    }

    window.addEventListener('resize', () => initializeOfferArrows());
    document.addEventListener('shopify:section:load', (event) => initializeOfferArrows(event.target));
  }

  } catch(e) { console.error(e); }
})();
})();
